export const ACCESS_RIGHTS_CHUNK = 'AccessRights';
